import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=3268aa12&"
import script from "./Saturation.vue?vue&type=script&lang=js&"
export * from "./Saturation.vue?vue&type=script&lang=js&"
import style0 from "./Saturation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3268aa12')) {
      api.createRecord('3268aa12', component.options)
    } else {
      api.reload('3268aa12', component.options)
    }
    module.hot.accept("./Saturation.vue?vue&type=template&id=3268aa12&", function () {
      api.rerender('3268aa12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Saturation.vue"
export default component.exports